/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Activity_Panel_CloseInputs */



/**
* | output |
* | --- |
* | "Close" |
*
* @param {Chat_Activity_Panel_CloseInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_activity_panel_close = /** @type {((inputs?: Chat_Activity_Panel_CloseInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Activity_Panel_CloseInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Sluiten")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fermer")
	return /** @type {LocalizedString} */ ("Close")
});